var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22.885,
    viewBox: "0 0 23 22.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_132",
    "data-name": "\\uADF8\\uB8F9 132",
    transform: "translate(-0.002 -0.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M22.548.08H9.61A2.465,2.465,0,0,0,7.13,2.545V15.484a2.458,2.458,0,0,0,2.458,2.509H22.727a2.465,2.465,0,0,0,2.279-2.487V2.567A2.465,2.465,0,0,0,22.548.08Zm.2,13.405a.438.438,0,0,1-.474.367h-1.8a4.428,4.428,0,0,0-8.819,0h-1.8a.438.438,0,0,1-.474-.367V2.7a.431.431,0,0,1,.474-.367H22.275a.431.431,0,0,1,.474.367Z",
    transform: "translate(-2.004)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11",
    "data-name": "\\uD328\\uC2A4 11",
    d: "M4.385,17.395V6.8l-2.48.575a2.458,2.458,0,0,0-1.84,2.947L2.983,22.951a2.458,2.458,0,0,0,2.947,1.84L18.56,21.873A2.451,2.451,0,0,0,20.2,20.6H7.584a3.2,3.2,0,0,1-3.2-3.206Zm9.682-10.3a2.1,2.1,0,1,0,2.092,2.1,2.1,2.1,0,0,0-2.092-2.1Z",
    transform: "translate(0 -1.89)",
    fill: "#e4e4e4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapIcon);
export default __webpack_public_path__ + "static/media/snap_icon.c60a9b6b5d46c74db5f1c5297c9dc8ea.svg";
export { ForwardRef as ReactComponent };